<template>
  <DynamicText
    tag="span"
    styleGroup="Fixture Time"
    :get="fixtureTimeFont.get"
    :set="fixtureTimeFont.set"
  >
    <slot />
  </DynamicText>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import DynamicText from "../DynamicText.vue";

import { Brand } from "@fresh8/types/src";

export default defineComponent({
  name: "BrandedDate",
  components: {
    DynamicText
  },
  setup() {
    return {
      fixtureTimeFont: {
        get(brand: Brand | undefined) {
          return brand?.adTemplate.market.fixtureTimeFont;
        },
        set(brand: Brand, value: string) {
          brand.adTemplate.market.fixtureTimeFont = value;
        }
      }
    };
  }
});
</script>
